import { render } from "@/components/pages/specialFeature/spWorkSupport/requirementSpES004/RequirementSpES004.html?vue&type=template&id=20af5140&scoped=true&external"
import script from "@/components/pages/specialFeature/spWorkSupport/requirementSpES004/RequirementSpES004.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spWorkSupport/requirementSpES004/RequirementSpES004.js?vue&type=script&lang=js&external"

import "@/components/pages/specialFeature/spWorkSupport/requirementSpES004/RequirementSpES004.scss?vue&type=style&index=0&id=20af5140&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20af5140"]])

export default __exports__